module.exports = __webpack_public_path__ + "static/media/1_1.c29fcef4.png";